export default __webpack_public_path__ + "assets/dashboard-learn-fb61f8797d2ed42826d1cfa5c7f16907.svg";